var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.type}},[_vm._v(_vm._s(_vm.msg))])
}
var staticRenderFns = []

export { render, staticRenderFns }